import { Epic, ofType } from 'redux-observable';
import { IshState } from '../../services/IshState';
import { Observable, mergeMap } from 'rxjs';
import {
  getAmount, setPayer, setRedeemVoucherActivity,
  TOGGLE_REDEEM_VOUCHER,
} from '../actions/Actions';
import { IAction } from '../../actions/IshAction';

export const EpicToggleRedeemVoucher: Epic<any, IshState> = (action$: Observable<any>): Observable<any> => {
  return action$.pipe(
    ofType(TOGGLE_REDEEM_VOUCHER),
    mergeMap((action:IAction<any>) => {

      const payload = action.payload;
      const payerId = payload.voucher.payer && payload.voucher.payer.id;

      return payerId && payload.enabled ?
        [
          setRedeemVoucherActivity(payload.voucher.id, payload.enabled),
          setPayer(payerId),
          getAmount(),
        ] :
        [
          setRedeemVoucherActivity(payload.voucher.id, payload.enabled),
          getAmount(),
        ];
    })
  );
};

